export const AuthLoginFormControlName = {
  Email: 'email',
  Password: 'password',
};

export default {
  AuthLoginFormControlName,
};
